import React from "react";
import {
  Briefcase,
  Coins,
  CreditCard,
  Smartphone,
  Ticket,
  Zap,
} from "lucide-react";

import type { CmsPromoSlide, PromoIconKey } from "../../types/homeLanding";
import type { PromoItem } from "../homeViewTypes";

import homeClasses from "./Home.module.scss";

type HomeClasses = typeof homeClasses;

const gradientClass = (key: CmsPromoSlide["gradientKey"], c: HomeClasses) => {
  switch (key) {
    case "miaPos":
      return c.promoGradMiaPos;
    case "mcBiz":
      return c.promoGradMcBiz;
    case "program373":
      return c.promoGrad373;
    case "depozit":
      return c.promoGradDepozit;
    case "valencia":
      return c.promoGradValencia;
    case "express":
      return c.promoGradExpress;
    default:
      return c.promoGradMiaPos;
  }
};

function PromoIcon({ iconKind }: { iconKind: PromoIconKey }) {
  const props = { size: 20 as const, color: "#fff" as const };
  switch (iconKind) {
    case "smartphone":
      return <Smartphone {...props} />;
    case "creditcard":
      return <CreditCard {...props} />;
    case "briefcase":
      return <Briefcase {...props} />;
    case "coins":
      return <Coins {...props} />;
    case "ticket":
      return <Ticket {...props} />;
    case "zap":
      return <Zap {...props} />;
    default:
      return <Briefcase {...props} />;
  }
}

export function mapCmsPromoToItem(
  slide: CmsPromoSlide,
  classes: HomeClasses,
): PromoItem {
  const tags =
    slide.tagText.trim().length > 0
      ? [{ text: slide.tagText.trim(), variant: slide.tagVariant }]
      : [];
  return {
    id: slide.id,
    tags,
    title: slide.title,
    desc: slide.description,
    icon: <PromoIcon iconKind={slide.iconKey} />,
    gradientClass: gradientClass(slide.gradientKey, classes),
    url: slide.url,
  };
}
